<template>
  <UiModal closeOnOverlay :show.sync="isShownModal">
    <div class="modal-container modal-scroll bg-white w-11/12 md:max-w-md mx-auto shadow-lg z-50 overflow-y-auto">
      <div class="modal-content text-left">
        <!--Title-->
        <div class="modal-header bg-danger text-white">
          <h5 class="modal-title">
            Thông báo
            <div class="modal-close" @click="closeModal">
              <img
                src="@/assets/img/icon-close-white.svg"
                alt="Close"
              />
            </div>
          </h5>
        </div>
        <!--Body-->
        <div class="modal-body">
          <h6>{{title}}</h6>
          <p>
            {{content}}
          </p>
        </div>
      </div>
    </div>
  </UiModal>
</template>

<script>
import UiModal from '@/components/UiModal'

export default {
  name: 'ModalRoot',
  components: {
    UiModal
  },
  data () {
    return {
      title: '',
      content: '',
      isShownModal: false
    }
  },
  methods: {
    closeModal () {
      this.isShownModal = false
    }
  },
  created () {
    this.$bus.$on('openModal', ({ title = '', content = '' }) => {
      this.title = title
      this.content = content
      this.isShownModal = true
    })
  }
}
</script>
